import { React, useEffect, useState } from "react";
import "./Sidebar.css";
import EmployeeSVG from "../SVGS/EmployeeSVG";
import NewsPaper from "../SVGS/NewsPaper";
import DashbboardSVG from "../SVGS/DashboardSVG";
import IHartLogoSVG from "../SVGS/IHartLogoSVG";
import AboutUsSVG from "../SVGS/AboutUsSVG";
import AuthorsSVG from "../SVGS/AuthorsSVG";
import CatageorySVG from "../SVGS/CatageorySVG";
import { NavLink, useNavigate } from "react-router-dom";
import Logo from "../../Assests/seeVitals.png";
import Contact from "../SVGS/Contact";
import { HiHome } from "react-icons/hi";
import { MdPeople, MdWbIridescent } from "react-icons/md";
import { BiSolidExtension } from "react-icons/bi";


function Sidebar() {
  const [screenName, setScreenName] = useState("Dashboard");
  let height = "24"; // these are the sizes of icons
  let width = "22";
  let size = "22";

  const navigate = useNavigate();
  useEffect(() => {
    let user = JSON.parse(localStorage.getItem("adminUser"));
    if (!user) {
      navigate("/");
    }
  }, []);

  return (
    <nav className="">
      <div className="sidebar_main">

        <div className="logo">
          {/* <img style={{ height: "67px", width: "73%" }} src={""} alt="logo" /> */}
          <IHartLogoSVG color="white" />
        </div>

        <div className="catageory">
          <div className="subCatBox">
            <NavLink
              to="/dashboard/dashPanel"
              className="subCat"
              style={({ isActive }) => {
                return {
                  backgroundColor: isActive ? "white" : "",
                  color: isActive ? "#EE282E" : "",
                  textDecoration: "none",
                  border: "none",
                  borderRadius: "7px",
                };
              }}
            >
              <span className="subCatsvgs">
                <DashbboardSVG
                  fill="currentColor"
                  stroke="currentColor"
                  height={height}
                  width={width}
                  size={size}
                />
              </span>
              <span
                className="subCatText"
                style={{
                  display: "flex",
                  justifyContent: "center",
                  height: "27px",
                }}
              >
                Dashboard
              </span>
            </NavLink>

            <NavLink
              to="/dashboard/home"
              className="subCat"
              style={({ isActive }) => {
                return {
                  backgroundColor: isActive ? "white" : "",
                  color: isActive ? "#EE282E" : "",
                  textDecoration: "none",
                  border: "none",
                  borderRadius: "7px",
                };
              }}
            >
              <span className="subCatsvgs">
                <HiHome size={size} />
              </span>
              <span
                className="subCatText"
                style={{
                  display: "flex",
                  justifyContent: "center",
                  height: "27px",
                }}
              >
                Home
              </span>
            </NavLink>

            <NavLink
              to="/dashboard/about"
              className="subCat"
              style={({ isActive }) => {
                return {
                  backgroundColor: isActive ? "white" : "",
                  color: isActive ? "#EE282E" : "",
                  textDecoration: "none",
                  border: "none",
                  borderRadius: "7px",
                };
              }}
            >
              <span className="subCatsvgs">
                <AboutUsSVG fill="currentColor"
                  stroke="currentColor"
                  height={height}
                  width={width}
                  size={size} />
              </span>
              <span
                className="subCatText"
                style={{
                  display: "flex",
                  justifyContent: "center",
                  height: "27px",
                }}
              >
                About Us
              </span>
            </NavLink>


            <NavLink
              to="/dashboard/team"
              className="subCat"
              style={({ isActive }) => {
                return {
                  backgroundColor: isActive ? "white" : "",
                  color: isActive ? "#EE282E" : "",
                  textDecoration: "none",
                  border: "none",
                  borderRadius: "7px",
                };
              }}
            >
              <span className="subCatsvgs">
                <MdPeople size={size} />
              </span>
              <span
                className="subCatText"
                style={{
                  display: "flex",
                  justifyContent: "center",
                  height: "27px",
                }}
              >
                Team
              </span>
            </NavLink>


            <NavLink
              to="/dashboard/services"
              className="subCat"
              style={({ isActive }) => {
                return {
                  backgroundColor: isActive ? "white" : "",
                  color: isActive ? "#EE282E" : "",
                  textDecoration: "none",
                  border: "none",
                  borderRadius: "7px",
                };
              }}
            >
              <span className="subCatsvgs">
                <BiSolidExtension size={size} />
              </span>
              <span
                className="subCatText"
                style={{
                  display: "flex",
                  justifyContent: "center",
                  height: "27px",
                }}
              >
                Services
              </span>
            </NavLink>

            <NavLink
              to="/dashboard/solutions"
              className="subCat"
              style={({ isActive }) => {
                return {
                  backgroundColor: isActive ? "white" : "",
                  color: isActive ? "#EE282E" : "",
                  textDecoration: "none",
                  border: "none",
                  borderRadius: "7px",
                };
              }}
            >
              <span className="subCatsvgs">
                <MdWbIridescent size={size} />
              </span>
              <span
                className="subCatText"
                style={{
                  display: "flex",
                  justifyContent: "center",
                  height: "27px",
                }}
              >
                Solutions
              </span>
            </NavLink>

            <NavLink
              to="/dashboard/clients"
              className="subCat"
              style={({ isActive }) => {
                return {
                  backgroundColor: isActive ? "white" : "",
                  color: isActive ? "#EE282E" : "",
                  textDecoration: "none",
                  border: "none",
                  borderRadius: "7px",
                };
              }}
            >
              <span className="subCatsvgs">
                <EmployeeSVG
                  fill="currentColor"
                  stroke="currentColor"
                  height={height}
                  width={width}
                  size={size}
                />
              </span>
              <span
                className="subCatText"
                style={{
                  display: "flex",
                  justifyContent: "center",
                  height: "27px",
                }}
              >
                Clients
              </span>
            </NavLink>


            <NavLink
              to="authors"
              className="subCat"
              style={({ isActive }) => {
                return {
                  backgroundColor: isActive ? "white" : "",
                  color: isActive ? "#EE282E" : "",
                  textDecoration: "none",
                  border: "none",
                  borderRadius: "7px",
                };
              }}
            >
              <span className="subCatsvgs">
                <AuthorsSVG
                  fill="currentColor"
                  stroke="currentColor"
                  height={height}
                  width={width}
                  size={size}
                />
              </span>
              <span
                style={{
                  display: "flex",
                  justifyContent: "center",
                  height: "26px",
                }}
              >
                Authors
              </span>
            </NavLink>

            <NavLink
              to="publications"
              className="subCat"
              style={({ isActive }) => {
                return {
                  backgroundColor: isActive ? "white" : "",
                  color: isActive ? "#EE282E" : "",
                  textDecoration: "none",
                  border: "none",
                  borderRadius: "7px",
                };
              }}
            >
              <span className="subCatsvgs">
                <NewsPaper
                  fill="currentColor"
                  stroke="currentColor"
                  height={height}
                  width={width}
                  size={size}
                />
              </span>
              <span>Publications</span>
            </NavLink>

            <NavLink
              to="/dashboard/recentNews"
              className="subCat"
              style={({ isActive }) => {
                return {
                  backgroundColor: isActive ? "white" : "",
                  color: isActive ? "#EE282E" : "",
                  textDecoration: "none",
                  border: "none",
                  borderRadius: "7px",
                };
              }}
            >
              <span className="subCatsvgs">
                <DashbboardSVG
                  fill="currentColor"
                  stroke="currentColor"
                  height={height}
                  width={width}
                  size={size}
                />
              </span>
              <span
                className="subCatText"
                style={{
                  display: "flex",
                  justifyContent: "center",
                  height: "27px",
                }}
              >
                Recent News & Notifications
              </span>
            </NavLink>

            <NavLink
              to="news&Events"
              className="subCat"
              style={({ isActive }) => {
                return {
                  backgroundColor: isActive ? "white" : "",
                  color: isActive ? "#EE282E" : "",
                  textDecoration: "none",
                  border: "none",
                  borderRadius: "7px",
                };
              }}
            >
              <span className="subCatsvgs">
                <NewsPaper
                  fill="currentColor"
                  stroke="currentColor"
                  height={height}
                  width={width}
                  size={size}
                />
              </span>
              <span>News and Events</span>
            </NavLink>

            <NavLink
              to="newsEventCatageory"
              className="subCat"
              style={({ isActive }) => {
                return {
                  backgroundColor: isActive ? "white" : "",
                  color: isActive ? "#EE282E" : "",
                  textDecoration: "none",
                  border: "none",
                  borderRadius: "7px",
                };
              }}
            >
              <span className="subCatsvgs">
                <CatageorySVG
                  fill="currentColor"
                  stroke="currentColor"
                  height={height}
                  width={width}
                  size={size}
                />
              </span>
              <span>News and Events Catageories</span>
            </NavLink>

            <NavLink
              to="contactUsers"
              className="subCat"
              style={({ isActive }) => {
                return {
                  backgroundColor: isActive ? "white" : "",
                  color: isActive ? "#EE282E" : "",
                  textDecoration: "none",
                  border: "none",
                  borderRadius: "7px",
                };
              }}
            >
              <span className="subCatsvgs">
                <Contact
                  fill="currentColor"
                  stroke="currentColor"
                  height={height}
                  width={width}
                  size={size}
                />
              </span>
              <span>Contact</span>
            </NavLink>
          </div>
        </div>
      </div>


    </nav>
  );
}

export default Sidebar;
